import { render } from "./MenuItemTools.vue?vue&type=template&id=a5985212&scoped=true"
import script from "./MenuItemTools.vue?vue&type=script&lang=js"
export * from "./MenuItemTools.vue?vue&type=script&lang=js"

import "./MenuItemTools.vue?vue&type=style&index=0&id=a5985212&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5985212"]])

export default __exports__